import React from 'react';
import { FlatfileProvider } from '@flatfile/react';
import { config } from 'client-config';

export const FlatfileWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <FlatfileProvider
      publishableKey={config.flatfile.FLATFILE_PUBLISHABLE_KEY}
      config={{ displayAsModal: true }}
    >
      {children}
    </FlatfileProvider>
  );
};
